;window.googlemaps = (function ($) {

    "use strict";

    var googlemaps = {

      map1: null,
      map2: null,

      addressLabel: '',
      address: {lat: 50.096888, lng: 14.422139},
      // center: {lat: 50.097, lng: 14.425138},
      options: [],
      styles: [],

      init: function(parentClass, holderClass) {

        var activeTab = document.getElementsByClassName(parentClass + '--active')[0];
        var holder = activeTab.getElementsByClassName(holderClass)[0];

        googlemaps.addressLabel = $(holder).data('address');
        googlemaps.address.lat = $(holder).data('lat');
        googlemaps.address.lng = $(holder).data('lng');

        googlemaps.loadRegularMap(holder);
        // googlemaps.loadPanoramaMap();

      },

      loadRegularMap: function(el) {
        // load styles
        $.getJSON('www/data/map-styles.json', function(data) {
          if (data) {
            googlemaps.styles = data;
          }
          else {
            console.log('Data Styles not exist, use the default');
          }

          // load map
          googlemaps.map1 = new google.maps.Map(el, {
            // center: googlemaps.center,
            center: googlemaps.address,
            styles: googlemaps.styles,
            zoom: 15,
            disableDefaultUI: true,
            // panControl: true,
            // fullscreenControl: true,
            // draggable: false,
            zoomControl: true,
            scrollwheel: false,
          });


          // set marker
          // var image = 'images/marker.svg';
          // var marker = new google.maps.Marker({
          //   position: googlemaps.address,
          //   map: googlemaps.map1,
          //   title: 'Gennet',
          //   icon: image,
          // });

          // marker and label as a custom marker (one svg)
          var myLatlng = new google.maps.LatLng(googlemaps.address.lat, googlemaps.address.lng);
          var overlay = new CustomMarker(
            myLatlng,
            googlemaps.map1,
            {
              marker_id: '#marker-label'
            },
            googlemaps.addressLabel
          );
        });
      },

      loadPanoramaMap: function() {
        // load panorama map
        googlemaps.map2 = new google.maps.Map(document.getElementById('google-street'), {
          center: googlemaps.address,
          styles: googlemaps.styles,
          zoom: 15
        });

        var panorama = new google.maps.StreetViewPanorama(document.getElementById('google-street'), {
          position: googlemaps.address,
          pov: {
            heading: 34,
            pitch: 10,
          }
        });
        googlemaps.map2.setStreetView(panorama);
      }
    };

    return googlemaps;


})(jQuery);